// PAWTY Judge.me text overrides
(function() {
  function overrideJudgeMe() {
    if (window.jdgmSettings) {
      window.jdgmSettings.widget_open_form_text = 'Leave a review for 20% off your next order! 🎉';
      window.jdgmSettings.widget_no_review_text = 'Be the first to leave a review for 20% off! 🎉';
    }
    // DOM fallback for already-rendered elements
    document.querySelectorAll('.jdgm-write-rev-link').forEach(function(el) {
      if (el.textContent.trim() === 'Write a review') {
        el.textContent = 'Leave a review for 20% off your next order! 🎉';
      }
    });
    document.querySelectorAll('.jdgm-rev-widg__no-rev-text').forEach(function(el) {
      if (el.textContent.trim().indexOf('Be the first to write') === 0) {
        el.textContent = 'Be the first to leave a review for 20% off! 🎉';
      }
    });
  }
  
  // Run immediately
  overrideJudgeMe();
  
  // Run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', overrideJudgeMe);
  
  // MutationObserver for dynamic rendering
  var observer = new MutationObserver(function() { overrideJudgeMe(); });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
  
  // Also run after a delay as final fallback
  setTimeout(overrideJudgeMe, 2000);
  setTimeout(overrideJudgeMe, 5000);
})();
